"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yarrAoTdrocer = exports.mkRecord = exports.reduceRecords = exports.unsetValue = exports.setValue = exports.getValueOrThrow = exports.getValueOrDefault = exports.getValueOrDefaultTo = exports.hasValue = void 0;
function hasValue(record, key) {
    return Object.prototype.hasOwnProperty.call(record, key) && record[key] !== null;
}
exports.hasValue = hasValue;
function getValueOrDefaultTo(record, key, defaultValue) {
    if (!hasValue(record, key)) {
        record[key] = defaultValue;
    }
    return record[key];
}
exports.getValueOrDefaultTo = getValueOrDefaultTo;
function getValueOrDefault(record, key, defaultValue) {
    if (!hasValue(record, key)) {
        return defaultValue;
    }
    return record[key];
}
exports.getValueOrDefault = getValueOrDefault;
function getValueOrThrow(record, key, message) {
    if (!hasValue(record, key)) {
        throw new Error(message);
    }
    return record[key];
}
exports.getValueOrThrow = getValueOrThrow;
function setValue(record, key, value) {
    record[key] = value;
    return value;
}
exports.setValue = setValue;
function unsetValue(record, key) {
    delete record[key];
}
exports.unsetValue = unsetValue;
function reduceRecords(reduce, ...records) {
    return records
        .reduce((merged, record) => Object.entries(record)
        .reduce((merged, [next, value]) => {
        merged[next] = hasValue(merged, next) ? reduce(merged[next], value, next)
            : value;
        return merged;
    }, merged), {});
}
exports.reduceRecords = reduceRecords;
function mkRecord(values, keyOf, valueOf = (_, self) => self) {
    return values.reduce((all, next) => {
        const key = keyOf(next);
        all[key] = valueOf(key, next);
        return all;
    }, {});
}
exports.mkRecord = mkRecord;
exports.yarrAoTdrocer = mkRecord;
